import { render, staticRenderFns } from "./SampleInfo.vue?vue&type=template&id=b813b872&scoped=true&"
import script from "./SampleInfo.vue?vue&type=script&lang=js&"
export * from "./SampleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SampleInfo.vue?vue&type=style&index=0&id=b813b872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b813b872",
  null
  
)

export default component.exports